module.exports = __webpack_public_path__ + "static/media/hamburger-menu-gray.5d63505f.svg";